import SidebarBookingsAiRoute from 'uplisting-frontend/pods/-sidebar/bookings/ai/route';

export default class ProtectionOverviewBookingsAiRoute extends SidebarBookingsAiRoute {
  parentRoute = 'protection.overview.bookings';
  occasionType = 'booking' as const;
}
